/* eslint-disable quotes */
/* eslint-disable no-case-declarations */
/* eslint-disable no-alert */
/* eslint-disable curly */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-restricted-globals */
/* eslint-disable radix */
import React, { useState, useEffect } from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { myLeadsState } from 'Stores/myLeads';
import { makeApi, URLS } from 'Utils/apiUtil';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { userDetail } from 'Stores/userDetail';
import SalesgearExportCRM from 'Components/salesgear/SalesgearExportCRM';
import SalesgearUpgradePopup from 'Components/salesgear/shared/SalesgearUpgradePopup';
import SalesgearConnectInbox from 'Components/salesgear/shared/SalesgearConnectInbox';
import { loginValidate } from 'Utils/commonApi';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import SalesgearLogo from 'Assets/logo/salesgear/sg64.png';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as CsvExportIcon } from 'Assets/svg/export_icons/csv_export.svg';
import { ReactComponent as SalesforceExportIcon } from 'Assets/svg/export_icons/salesforce_export.svg';
import { ReactComponent as ZohoExportIcon } from 'Assets/svg/export_icons/zoho_export.svg';
import { ReactComponent as PipedriveExportIcon } from 'Assets/svg/export_icons/pipedrive_export.svg';
import { ReactComponent as HubspotExportIcon } from 'Assets/svg/export_icons/hubspot_export.svg';
import { ReactComponent as OutreachExportIcon } from 'Assets/svg/export_icons/outreach.svg';
import { ReactComponent as MarketoExportIcon } from 'Assets/svg/export_icons/marketo.svg';
import { ReactComponent as MicrosoftDynamicsExportIcon } from 'Assets/svg/export_icons/microsoft_dynamics.svg';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import SalesgearAPIConnect from 'Components/salesgear/salesgearAPIConnect';
import { advSearchState } from 'Stores/advSearch';
import crmIntegrationState from 'Stores/crmIntegration';
import { commonUpgradePopupState } from 'Components/common/commonUpgradePopup';
import { ExportLeadsTypePopup, exportTypeState } from './exportType';
import {
  PipedriveAuthenticationPopup,
  pipedriveExportState,
} from './pipedriveExport';
import {
  MarketoAuthenticationPopup,
  marketoExportState,
} from './marketoExport';
import {
  MicrosoftDynamicsAuthenticationPopup,
  microsoftDynamicsExportState,
} from './microsoftDynamicsExport';
import {
  outreachSequenceState,
  OutreachSequencePopup,
} from './outreachSequencePopup';
import {
  OwnershipMappingPopup,
  ownershipMappingState,
} from './ownershipMapping';

const {
  CRM_EXPORT_TYPE,
  CRM_EXPORT_LIMIT,
  EXPORT_SOURCE,
  EXPORT_PAGE_SOURCE,
  CONTACT_EXPORT_TYPES,
  CRM_EXPORT_AS_TYPE,
  UPGRADE_TRIGGERS,
} = CONSTANTS;
const { ADVANCED_SEARCH, MY_LEADS } = EXPORT_SOURCE;
const {
  ASYNC_EXPORT,
  DIRECT_EXPORT,
  ASYNC_EXPORT_CRITERIA,
} = CONTACT_EXPORT_TYPES;

const exportOptions = [
  {
    label: 'CSV',
    icon: CsvExportIcon,
    className: 'csv-icon',
  },
  {
    label: 'Salesgear',
    icon: SalesgearLogo,
    className: 'salesgear-icon',
  },
  {
    label: 'Salesforce',
    icon: SalesforceExportIcon,
    className: 'salesforce-icon',
  },
  {
    label: 'Zoho',
    icon: ZohoExportIcon,
    className: 'zoho-icon',
  },
  {
    label: 'Pipedrive',
    icon: PipedriveExportIcon,
    className: 'pipedrive-icon',
  },
  {
    label: 'Hubspot',
    icon: HubspotExportIcon,
    className: 'hubspot-icon',
  },
  {
    label: 'Outreach',
    icon: OutreachExportIcon,
    className: 'outreach-icon',
  },
  {
    label: CRM_EXPORT_TYPE.MARKETO,
    icon: MarketoExportIcon,
    className: 'marketo-icon',
  },
];

const allExportTypes = [
  'CSV',
  'Salesgear',
  'Salesforce',
  'Zoho',
  'Pipedrive',
  'Hubspot',
  'Outreach',
  CRM_EXPORT_TYPE.MARKETO,
];

let oAuthWindow = null;
let OAuthWindowOpened = false;

const defaultExportMxData = {
  pageType: 'AS', // AS/ML
  searchType: 'CONTACT',
};

class ExportLeadsState {
  @observable showExportLeads = false;

  @observable exportOption = '';

  @observable showProcessingExport = false;

  @observable exportPostData = {};

  @observable exportMxData = defaultExportMxData;

  @observable exportSource = '';

  @observable isCrmExportLimitCrossed = false;

  additionalOptions = {
    callback: () => {},
    customExportCallback: null,
  };

  @action
  setShowExportLeads = (val, options = {}) => {
    this.showExportLeads = val;
    if (Object.keys(options).length > 0) {
      this.additionalOptions.callback = options.callback;
      this.additionalOptions.customExportCallback =
        options.customExportCallback;
    } else {
      this.additionalOptions = {
        callback: () => {},
        customExportCallback: null,
      };
    }
  };

  @action
  setExportOption = val => {
    this.exportOption = val;
  };

  @action
  setExportPostData = (val = {}) => {
    this.exportPostData = val;
  };

  @action
  setExportMxData = (val = defaultExportMxData) => {
    this.exportMxData = { ...this.exportMxData, ...val };
  };

  @action
  setExportSource = (val = '') => {
    this.exportSource = val;

    this.setExportMxData({ pageType: 'ML' });
  };

  @action
  setIsCrmExportLimitCrossed = (val = false) => {
    this.isCrmExportLimitCrossed = val;
  };

  @action
  setShowProcessingExport = value => {
    this.showProcessingExport = value;
  };

  @action
  checkIsAdvExport = () => {
    const thisObj = this;
    if (thisObj.exportSource === ADVANCED_SEARCH) return true;

    return false;
  };

  @action
  checkIsAdvBulkExport = () => {
    const thisObj = this;
    if (thisObj.exportSource === ADVANCED_SEARCH)
      if (
        advSearchState &&
        (advSearchState.selectedContactFromRange ||
          advSearchState.selectedAllContactAcrossPage)
      )
        return true;

    return false;
  };

  @action
  checkAndexport = (str, source, exportOption, isExportEnabled) => {
    const thisObj = this;
    this.exportPostData = {};

    if (!isExportEnabled) {
      Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_EXPORT_UPGRADE_CLICK, {
        type: str,
        optionType: exportOption,
      });

      if (Utils.isStarterPlanActive()) {
        commonUpgradePopupState.setShowUpgradePopup(
          UPGRADE_TRIGGERS.STARTER_CRM_EXPORT,
        );
      } else if (exportOption === 'export all')
        commonUpgradePopupState.setShowUpgradePopup(
          UPGRADE_TRIGGERS.EXPORT_LIST_IN_MY_LEADS,
        );
      else if (str === 'CSV')
        commonUpgradePopupState.setShowUpgradePopup(
          UPGRADE_TRIGGERS.EXPORT_SELECTED_TO_CSV_IN_MY_LEADS,
        );
      else
        commonUpgradePopupState.setShowUpgradePopup(
          UPGRADE_TRIGGERS.EXPORT_SELECTED_TO_CRM_IN_MY_LEADS,
        );

      thisObj.setShowExportLeads(false);
    }

    if (isExportEnabled) {
      Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_EXPORT_TYPE_CLICK, {
        type: str,
        optionType: exportOption,
        ...(this.exportSource === MY_LEADS
          ? {
              currentTab:
                CONSTANTS.MY_LEADS_TABS[
                  parseInt(
                    Utils.getQueryParamFromUrl('tab', window.location.href) ||
                      0,
                  )
                ],
            }
          : {}),
      });

      if (
        this.additionalOptions.customExportCallback !== null &&
        typeof this.additionalOptions.customExportCallback === 'object' &&
        typeof this.additionalOptions.customExportCallback[str] === 'function'
      ) {
        this.additionalOptions.customExportCallback[str]();
        thisObj.setShowExportLeads(false);
      } else {
        if (str === 'CSV') {
          this.exportLeadsToCSV(str, source, exportOption);
          thisObj.setShowExportLeads(false);
        }
        if (!thisObj.isCrmExportLimitCrossed) {
          if (str === 'Salesforce') {
            const exportAs =
              // eslint-disable-next-line camelcase
              userDetail.userInfo.teamCRMPreferences?.SALESFORCE?.export_as;
            this.exportLeadsToCRM({
              type: CRM_EXPORT_TYPE.SALESFORCE,
              source,
              option: exportOption,
              ...(exportAs && { exportAs: exportAs.toUpperCase() }),
            });
          } else if (str === 'Zoho')
            this.exportContactsToZoho(str, source, exportOption);
          else if (str === 'Outreach')
            this.exportContactsToOutreach(str, source, exportOption);
          else if (str === 'Pipedrive')
            this.exportLeadsToPipedrive(str, source, exportOption);
          else if (str === 'Hubspot')
            this.exportLeadsToCRM({
              type: CRM_EXPORT_TYPE.HUBSPOT,
              source,
              option: exportOption,
              exportAs: CRM_EXPORT_AS_TYPE.CONTACT,
            });
          else if (str === CRM_EXPORT_TYPE.MARKETO)
            this.exportLeadsToMarketo(str, source, exportOption);
          else if (str === CRM_EXPORT_TYPE.MICROSOFT_DYNAMICS)
            thisObj.exportLeadsToMicrosoftDynamics(str, source, exportOption);

          thisObj.setShowExportLeads(false, this.additionalOptions);
        }
      }
    }
  };

  @action
  exportContactsMakeApiCall = (apiUrl, callBack, appendPostData = false) => {
    const thisObj = this;
    const postData = Utils.copyObjectWithoutReference(thisObj.exportPostData);
    if (appendPostData) postData.exportSource = thisObj.exportSource;

    if (postData.exportRequestCount !== undefined)
      delete postData.exportRequestCount;

    const config = {
      url: apiUrl,
      method: 'POST',
      data: postData,
    };
    makeApi(config)
      .then(response => {
        callBack(response);
        // thisObj.resultLoading = false;
      })
      .catch(error => {
        // this.resultLoading = false;
        console.log('suggestionList error ', error);
      });
  };

  @action
  pipeDriveExport = (inputValues = null, selectedSrc) => {
    const thisObj = this;
    this.showProcessingExport = true;
    const apiConfig = {
      url: URLS.pipeDriveToken ? URLS.pipeDriveToken : '',
      method: 'POST',
      data: inputValues
        ? {
            token: inputValues.apikey ? inputValues.apikey : '',
            instanceUrl: inputValues.companyDomain
              ? inputValues.companyDomain
              : '',
          }
        : {},
    };
    this.showProcessingExport = true;
    makeApi(apiConfig)
      .then(res => {
        this.showProcessingExport = false;
        const resData = res && res.data ? res.data : {};
        const { status, errorType } = resData || '';
        this.showProcessingExport = false;
        if (status === 'success') {
          loginValidate();
          this.constructExportStatusPopup('Success', resData, 'Pipedrive');
        } else if (status === 'failure' && errorType === 'generic') {
          const emptyCbk = () => {};
          Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_EXPORT_FAILED, {
            type: selectedSrc,
          });
          confirmationPopupState.setPopupValues({
            title: `${selectedSrc} Export Failed`,
            content:
              'An error occured while exporting the contact. Please try again or contact <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>.',
            actionBtnText: 'OK',
            callback: emptyCbk,
          });
          confirmationPopupState.setShowPopup(true);
        } else {
          const emptyCbk = () => {};
          Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_EXPORT_FAILED, {
            type: selectedSrc,
          });
          confirmationPopupState.setPopupValues({
            title: `${selectedSrc} Export Failed`,
            content: resData.msg
              ? resData.msg
              : 'An error occured while exporting the contact. Please try again or contact <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>.',
            actionBtnText: 'OK',
            callback: emptyCbk,
          });
          confirmationPopupState.setShowPopup(true);
        }
        thisObj.clearSelectedContacts();
      })
      .catch(error => {
        this.showProcessingExport = false;
        console.log('Pipedrive error ', error);
      });
  };

  @action
  clearSelectedContacts = () => {
    const thisObj = this;
    if (thisObj.checkIsAdvExport()) advSearchState.clearAllSelection(true);
    else myLeadsState.clearPreviouslySelectedConatcts();
  };

  @action
  constructExportStatusPopup = (
    statusType = 'Success',
    result,
    selectedSrc = '',
    customMsg,
  ) => {
    const thisObj = this;
    thisObj.clearSelectedContacts();
    let msgStr = '';
    const emptyCbk = () => {};
    let exportStatusType = statusType;
    if (customMsg !== undefined && customMsg !== '') {
      msgStr = customMsg;
    } else {
      Utils.totangoTrack(selectedSrc, CONSTANTS.TOTANGO.MODULES.MY_LEADS);
      const {
        exportSuccessCount,
        newDownloadedCount,
        exportFailedCount,
        duplicateLeadCount,
        errorType,
        creditsReduced,
        contactIdsWithoutEmail = [],
      } = result || '';
      const LeadName =
        exportSuccessCount && exportSuccessCount > 1 ? 'Leads' : 'Lead';
      const failLeadName = exportFailedCount > 1 ? 'Leads' : 'Lead';

      let totalCount = exportSuccessCount ? parseInt(exportSuccessCount) : 0;
      totalCount += exportFailedCount ? parseInt(exportFailedCount) : 0;
      totalCount += duplicateLeadCount ? parseInt(duplicateLeadCount) : 0;

      let deductedCount = 0;
      let creditType = 'download';
      if (Utils.isCreditBasedSubscription()) {
        creditType = 'credit';
        deductedCount = creditsReduced && parseInt(creditsReduced);
      } else {
        deductedCount = newDownloadedCount && parseInt(newDownloadedCount);
      }

      const duplicateCount = duplicateLeadCount && duplicateLeadCount;
      const dupLeadName = duplicateCount > 1 ? 'Leads' : 'Lead';
      if (exportSuccessCount > 0 || duplicateCount > 0) {
        exportStatusType = 'Success';
        if (exportSuccessCount > 0)
          msgStr = `${exportSuccessCount} ${LeadName} exported successfully <br/>
                ${deductedCount === 0 ? 'No' : deductedCount} ${creditType}${
            deductedCount > 1 ? 's' : ''
          } deducted. <br/>`;
        msgStr +=
          exportFailedCount > 0
            ? `${exportFailedCount} ${failLeadName} export failed. <br/>`
            : '';

        msgStr +=
          duplicateCount > 0
            ? ` ${duplicateCount} ${dupLeadName} not exported as they already exist in your ${selectedSrc} account.`
            : '';

        if (
          exportFailedCount > 0 &&
          Utils.isCreditBasedSubscription() &&
          contactIdsWithoutEmail.length > 0
        )
          msgStr +=
            // eslint-disable-next-line quotes
            "<div class='note'><span class='note-title'>Note :</span><span>Contacts without email will not be exported.</span></div>";

        thisObj.trackPurchaseEvent(selectedSrc, totalCount, null);
      } else {
        Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_EXPORT_FAILED, {
          type: selectedSrc,
          reason: customMsg !== undefined && customMsg !== '' ? customMsg : '',
        });
        exportStatusType = 'Failed';
        if (errorType === 'CONTACT_ALREADY_PRESENT_IN_SEQUENCE') {
          msgStr =
            '1 Lead not exported as they already exist in your Salesgear account.';
        } else if (
          contactIdsWithoutEmail.length === totalCount &&
          contactIdsWithoutEmail.length === 1
        ) {
          msgStr =
            "Hey! It looks like this contact doesn't have an email address and hence we are not exporting this contact.";
        } else if (
          contactIdsWithoutEmail.length === totalCount &&
          contactIdsWithoutEmail.length > 1
        ) {
          msgStr =
            "Hey! It looks like these contacts doesn't have email address and hence we are not exporting these contacts.";
        } else {
          msgStr = `An error occured while exporting the ${failLeadName}. Please try again or contact <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>.`;
          if (
            exportFailedCount > 0 &&
            Utils.isCreditBasedSubscription() &&
            contactIdsWithoutEmail.length > 0 &&
            contactIdsWithoutEmail.length !== totalCount
          )
            msgStr +=
              // eslint-disable-next-line quotes
              "<div class='note'><span class='note-title'>Note :</span><span>Contacts without email will not be exported.</span></div>";
        }
      }
    }
    confirmationPopupState.setPopupValues({
      customClassName: 'my-leads-export-popup',
      title: `${selectedSrc} Export ${exportStatusType}`,
      content: msgStr,
      actionBtnText: 'OK',
      needCancelBtn: false,
      callback: emptyCbk,
    });
    this.showProcessingExport = false;
    confirmationPopupState.setShowPopup(true);
  };

  @action
  exportLeadsToCSV = (type, source, option) => {
    const thisObj = this;

    let paramsBody = {};
    paramsBody = {
      export_type: type,
      source,
      exportSource: thisObj.exportSource,
    };
    let exportLeadsCount = 1;
    const selectedListData = userDetail.myLeadList.find(
      data => data.id === myLeadsState.selectedList.id,
    );

    paramsBody.memberId =
      selectedListData?.memberId || userDetail.userInfo.memberId;
    paramsBody.teamId = userDetail.userInfo.teamId;
    paramsBody.sharedList = selectedListData?.isSharedList || false;

    if (option === 'export selected') {
      paramsBody.listId = myLeadsState.selectedList.id || '*';
      paramsBody.contactIds = myLeadsState.bulkPurchaseIds;
      exportLeadsCount = myLeadsState.bulkPurchaseIds.length;
    } else if (myLeadsState.selectedList.name !== 'All Leads') {
      paramsBody.listId = myLeadsState.selectedList.id;
      exportLeadsCount = myLeadsState.leadsResultCount;
    } else {
      exportLeadsCount = myLeadsState.leadsResultCount;
    }

    this.exportPostData = paramsBody;

    this.exportLeadsToCSVFlow(exportLeadsCount);
  };

  @action
  exportLeadsToCSVFlow = exportLeadsCount => {
    const thisObj = this;

    this.showProcessingExport = true;
    if (exportLeadsCount !== undefined && exportLeadsCount !== null) {
      thisObj.clearSelectedContacts();

      const csvExportCallback = response => {
        this.showProcessingExport = false;

        if (response.data?.status === 'success') {
          advSearchState.setAsyncPurchaseOrExportMsg('CSV_EXPORT');
        } else if (
          response &&
          response.data &&
          response.data.responseCode === 101
        ) {
          if (Utils.isFreeTrialPlan()) {
            userDetail.setShowUpgradeCreditPopup(true);
          } else if (
            userDetail.userInfo.memberSubscription !== null &&
            userDetail.userInfo.memberSubscription !== undefined
          ) {
            Utils.showCreditExpiredPopup('downloads');
          } else {
            this.setShowExportLeads(false);
            Utils.showUserPricingPopup(true, 'downloads', false);
          }
        } else {
          advSearchState.setAsyncPurchaseOrExportMsg('UNKNOWN_ERROR');
        }
      };

      this.exportContactsMakeApiCall(URLS.exportToCSVV2, csvExportCallback);
    }
  };

  @action
  exportLeadsToPipedrive = (type, source, option) => {
    const thisObj = this;

    let paramsBody = {};
    paramsBody = {
      export_type: type,
      source,
    };
    let exportLeadsCount = 1;

    if (option === 'export selected') {
      paramsBody.contactIds = myLeadsState.bulkPurchaseIds;
      exportLeadsCount = myLeadsState.bulkPurchaseIds.length;
    } else if (myLeadsState.selectedList.name !== 'All Leads') {
      paramsBody.listId = myLeadsState.selectedList.id;
      exportLeadsCount = myLeadsState.leadsResultCount;
    } else {
      exportLeadsCount = myLeadsState.leadsResultCount;
    }

    this.exportPostData = paramsBody;

    this.exportLeadsToPipedriveFlow(exportLeadsCount, true);
  };

  @action
  exportLeadsToPipedriveFlow = (exportLeadsCount, appendPostData = false) => {
    const thisObj = this;

    this.showProcessingExport = true;
    if (
      exportLeadsCount !== undefined &&
      exportLeadsCount !== null &&
      exportLeadsCount > CRM_EXPORT_LIMIT
    ) {
      thisObj.clearSelectedContacts();
      this.showProcessingExport = false;
      this.exportFailureLimit('Pipedrive', exportLeadsCount);
    } else {
      const pipedriveExportCallback = response => {
        this.showProcessingExport = false;

        if (response.data.status === 'auth_success') {
          this.pipeDriveExport(null, this.exportPostData.export_type);
        } else if (
          response &&
          response.data &&
          response.data.responseCode !== undefined &&
          response.data.responseCode === 102
        ) {
          this.showProcessingExport = false;
          const pipDriveCbk = inputValues => {
            this.pipeDriveExport(inputValues, this.exportPostData.export_type);
          };
          this.showProcessingExport = true;
          pipedriveExportState.setPopupValues({
            callback: pipDriveCbk,
          });
          this.showProcessingExport = false;
          pipedriveExportState.setShowPopup(true);
        } else {
          this.exportContactsResponseHandler(
            response,
            exportLeadsCount,
            'Pipedrive',
          );
        }
      };

      this.exportContactsMakeApiCall(
        URLS.exportLeadsToPipedrive,
        pipedriveExportCallback,
        appendPostData,
      );
    }
  };

  @action
  exportLeadsToMarketo = (type, source, option) => {
    const thisObj = this;

    let paramsBody = {};
    paramsBody = {
      export_type: type,
      source,
    };
    let exportLeadsCount = 1;

    if (option === 'export selected') {
      paramsBody.contactIds = myLeadsState.bulkPurchaseIds;
      exportLeadsCount = myLeadsState.bulkPurchaseIds.length;
    } else if (myLeadsState.selectedList.name !== 'All Leads') {
      paramsBody.listId = myLeadsState.selectedList.id;
      exportLeadsCount = myLeadsState.leadsResultCount;
    } else {
      exportLeadsCount = myLeadsState.leadsResultCount;
    }

    this.exportPostData = paramsBody;

    if (exportLeadsCount > CRM_EXPORT_LIMIT) {
      thisObj.clearSelectedContacts();
      this.showProcessingExport = false;
      this.exportFailureLimit('Marketo', exportLeadsCount);
    } else {
      this.exportLeadsToMarketoFlow(exportLeadsCount, null, true);
    }
  };

  @action
  exportLeadsToMarketoFlow = (
    exportLeadsCount,
    authData,
    appendPostData = false,
  ) => {
    const thisObj = this;

    const authDataBackup = JSON.parse(JSON.stringify(authData));
    thisObj.showProcessingExport = true;
    const marketoExportCallback = response => {
      thisObj.showProcessingExport = false;
      if (authDataBackup === null) {
        marketoExportState.setAuthValues();
      }

      const marketoAuthCallback = (errorRes = null) => {
        const marketoCbk = inputValues => {
          thisObj.exportLeadsToMarketoFlow(exportLeadsCount, inputValues);
        };
        marketoExportState.setPopupValues({
          callback: marketoCbk,
        });
        if (errorRes !== null) marketoExportState.setErrorResponse(errorRes);
        marketoExportState.setShowPopup(true);
      };
      thisObj.exportContactsResponseHandler(
        response,
        exportLeadsCount,
        CRM_EXPORT_TYPE.MARKETO,
        marketoAuthCallback,
      );
    };

    if (authData !== null) {
      let { exportPostData } = thisObj;
      exportPostData = { ...exportPostData, ...authData };
      thisObj.exportPostData = exportPostData;
    }

    thisObj.exportContactsMakeApiCall(
      URLS.exportLeadsToMarketo,
      marketoExportCallback,
      appendPostData,
    );
  };

  @action
  exportLeadsToMicrosoftDynamics = (type, source, option) => {
    const thisObj = this;

    let paramsBody = {};
    paramsBody = {
      export_type: type,
      source,
    };
    let exportLeadsCount = 1;

    if (option === 'export selected') {
      paramsBody.contactIds = myLeadsState.bulkPurchaseIds;
      exportLeadsCount = myLeadsState.bulkPurchaseIds.length;
    } else if (myLeadsState.selectedList.name !== 'All Leads') {
      paramsBody.listId = myLeadsState.selectedList.id;
      exportLeadsCount = myLeadsState.leadsResultCount;
    } else {
      exportLeadsCount = myLeadsState.leadsResultCount;
    }

    this.exportPostData = paramsBody;

    if (exportLeadsCount > CRM_EXPORT_LIMIT) {
      thisObj.clearSelectedContacts();
      this.showProcessingExport = false;
      this.exportFailureLimit('Microsoft Dynamics', exportLeadsCount);
    } else {
      this.exportLeadsToMicrosoftDynamicsFlow(exportLeadsCount, null, true);
    }
  };

  @action
  exportLeadsToMicrosoftDynamicsFlow = (
    exportLeadsCount,
    authData,
    appendPostData = false,
  ) => {
    const thisObj = this;

    const authDataBackup = JSON.parse(JSON.stringify(authData));
    thisObj.showProcessingExport = true;
    const microsoftDynamicsExportCallback = response => {
      thisObj.showProcessingExport = false;
      if (authDataBackup === null) {
        microsoftDynamicsExportState.setAuthValues();
      }

      const microsoftDynamicsAuthCallback = (errorRes = null) => {
        const microsoftDynamicsCbk = inputValues => {
          thisObj.exportLeadsToMicrosoftDynamicsFlow(
            exportLeadsCount,
            inputValues,
          );
        };
        microsoftDynamicsExportState.setPopupValues({
          title: `${CRM_EXPORT_TYPE.MICROSOFT_DYNAMICS} Export`,
          callback: microsoftDynamicsCbk,
          actionBtnText: 'Export',
        });
        if (errorRes !== null)
          microsoftDynamicsExportState.setErrorResponse(errorRes);
        microsoftDynamicsExportState.setShowPopup(true);
      };
      thisObj.exportContactsResponseHandler(
        response,
        exportLeadsCount,
        CRM_EXPORT_TYPE.MICROSOFT_DYNAMICS,
        microsoftDynamicsAuthCallback,
      );
    };
    let { exportPostData } = thisObj;
    if (
      exportPostData.save_type !== undefined &&
      exportPostData.save_type !== null
    ) {
      exportPostData.export_as = exportPostData.save_type;
      if (
        exportPostData.save_preference !== undefined &&
        exportPostData.save_preference === true
      )
        exportPostData.always_export_as = exportPostData.save_type;
    }

    if (authData !== null) {
      exportPostData = { ...exportPostData, ...authData };
      thisObj.exportPostData = exportPostData;
    }

    thisObj.exportContactsMakeApiCall(
      URLS.exportLeadsToMicrosoftDynamics,
      microsoftDynamicsExportCallback,
      appendPostData,
    );
  };

  @action
  exportContactsToOutreach = (type, source, option) => {
    const thisObj = this;

    let paramsBody = {};
    paramsBody = {
      export_type: type,
      source,
    };
    let exportLeadsCount = 1;

    if (option === 'export selected') {
      paramsBody.contactIds = myLeadsState.bulkPurchaseIds;
      exportLeadsCount = myLeadsState.bulkPurchaseIds.length;
    } else if (myLeadsState.selectedList.name !== 'All Leads') {
      paramsBody.listId = myLeadsState.selectedList.id;
      exportLeadsCount = myLeadsState.leadsResultCount;
    } else {
      exportLeadsCount = myLeadsState.leadsResultCount;
    }

    this.exportPostData = paramsBody;

    this.exportContactsToOutreachFlow(exportLeadsCount, '', '', '', '', true);
  };

  @action
  exportContactsToOutreachFlow = (
    exportLeadsCount,
    assignSequence,
    sequenceId = '',
    mailBoxId = '',
    tagValue = '',
    appendPostData = false,
  ) => {
    const thisObj = this;

    this.showProcessingExport = true;
    if (
      exportLeadsCount !== undefined &&
      exportLeadsCount !== null &&
      exportLeadsCount > CRM_EXPORT_LIMIT
    ) {
      thisObj.clearSelectedContacts();
      this.showProcessingExport = false;
      this.exportFailureLimit('Outreach', exportLeadsCount);
    } else {
      const outreachExportCallback = res => {
        this.showProcessingExport = false;
        this.exportContactsResponseHandler(res, exportLeadsCount, 'Outreach');
      };
      const { exportPostData } = this;
      if (assignSequence !== undefined && assignSequence === true)
        exportPostData.assignSequence = true;
      if (sequenceId !== undefined && sequenceId !== '')
        exportPostData.sequenceId = sequenceId;
      if (mailBoxId !== undefined && mailBoxId !== '')
        exportPostData.mailBoxId = mailBoxId;
      if (tagValue !== undefined && tagValue !== '')
        exportPostData.tag = tagValue;

      this.exportPostData = exportPostData;

      this.exportContactsMakeApiCall(
        URLS.exportLeadsToOutReach,
        outreachExportCallback,
        appendPostData,
      );
    }
  };

  // Deprecate this after all export moved to exportContactsToCrmResponseHandler
  @action
  exportContactsResponseHandler = (
    res,
    exportLeadsCount,
    exportType,
    customCallback = null,
  ) => {
    const thisObj = this;

    if (res && res.data) {
      const response = res.data;
      console.log('response ', response);
      console.log('response data ', res.data);
      const exportTypeVal =
        exportType !== undefined
          ? exportType
          : thisObj.exportPostData.export_type;
      if (response.responseCode === 102) {
        this.setShowExportLeads(false);
        if (
          customCallback !== null &&
          (exportType === CRM_EXPORT_TYPE.MARKETO ||
            (exportType === CRM_EXPORT_TYPE.MICROSOFT_DYNAMICS &&
              response.responseSubCode !== undefined &&
              response.responseSubCode === 102))
        ) {
          if (
            response.errorCode !== undefined &&
            response.errorDescription !== undefined
          ) {
            customCallback(response);
          } else {
            customCallback();
          }
        } else {
          this.openOAuthWindow(
            response.authUrl,
            `${exportType} Login`,
            900,
            600,
            exportType,
            exportLeadsCount,
            this.exportContactsResponseHandler,
          );
        }
      } else if (response.responseCode === 103) {
        if (exportTypeVal === CRM_EXPORT_TYPE.OUTREACH)
          this.showOutreachSequencePopUp();
        else if (exportTypeVal === CRM_EXPORT_TYPE.SALESFORCE)
          this.showPreferencePopUp(exportTypeVal);
        else if (exportTypeVal === CRM_EXPORT_TYPE.ZOHO)
          this.showPreferencePopUp(exportTypeVal, exportLeadsCount);
        else if (exportTypeVal === CRM_EXPORT_TYPE.HUBSPOT)
          this.askAssignOwnerShipPopup(exportTypeVal);
        else if (exportTypeVal === CRM_EXPORT_TYPE.MICROSOFT_DYNAMICS)
          this.showPreferencePopUp(exportTypeVal);
      } else if (response.responseCode === 104) {
        if (exportTypeVal === CRM_EXPORT_TYPE.SALESFORCE)
          thisObj.askAssignOwnerShipPopup(exportTypeVal);
      } else if (response.responseCode === 200) {
        if (exportTypeVal === 'CSV' && response.exportSuccessCount > 0)
          Utils.downloadToCsv(response);

        this.setShowExportLeads(false);
        thisObj.clearSelectedContacts();
        this.constructExportStatusPopup('Success', response, exportType);
        loginValidate();
      } else if (response.error === 'limit' || response.errorType === 'limit') {
        this.showProcessingExport = false;
        thisObj.clearSelectedContacts();
        thisObj.exportFailureLimit(exportTypeVal, exportLeadsCount, 5000);
      } else if (
        response.responseCode === 101 ||
        response.responseCode === 105 ||
        response.error === 'subscription' ||
        response.errorType === 'subscription' ||
        response.error === 'creditLimit' ||
        response.errorType === 'creditLimit'
      ) {
        if (
          userDetail.userInfo.memberSubscription !== null &&
          userDetail.userInfo.memberSubscription !== undefined
        ) {
          if (Utils.isFreeTrialPlan())
            userDetail.setShowUpgradeCreditPopup(true);
          else Utils.showCreditExpiredPopup('downloads');
        } else {
          this.setShowExportLeads(false);
          Utils.showUserPricingPopup(true, 'downloads', false);
        }
        this.showProcessingExport = false;
        thisObj.clearSelectedContacts();
      } else if (response.responseCode === 429) {
        // Outreach range limit exceed
        let timeToShow = 60;
        if (
          response.retryAfter &&
          response.retryAfter !== undefined &&
          response.retryAfter !== ''
        ) {
          const dateVal = response.retryAfter;
          const newDate = new Date(parseInt(dateVal));
          const curDate = new Date();

          const timestampDiff = newDate.getTime() - curDate.getTime();
          const secDiff = Math.floor(timestampDiff / 1000);
          const minsDiff = Math.floor(secDiff / 60);

          if (minsDiff > 45) timeToShow = 60;
          else if (minsDiff > 30) timeToShow = 45;
          else if (minsDiff > 15) timeToShow = 30;
          else timeToShow = 15;
        }

        const errorMsg = `You've reached Outreach's hourly limit. Please try again in another ${timeToShow} minutes`;
        this.constructExportStatusPopup('Failed', {}, exportType, errorMsg);
      } else if (
        response.responseCode === 500 &&
        response.exportSuccessCount &&
        parseInt(response.exportSuccessCount) > 0 &&
        response.exportFailedCount &&
        parseInt(response.exportFailedCount) > 0
      ) {
        const errorMsg = `We were able to export only ${parseInt(
          response.exportSuccessCount,
        )} contacts to ${exportType}. Please try again to export the remaining contacts.`;
        this.constructExportStatusPopup('Failed', {}, exportType, errorMsg);
      } else if (response.responseCode === 500) {
        if (
          exportType === CRM_EXPORT_TYPE.MICROSOFT_DYNAMICS &&
          response.error !== undefined &&
          response.error === 'AUTH_CODE'
        ) {
          const errorMsg = `This might be because there's mismatch in mapping the Resource URL with corresponding Microsoft Dynamics account. <br /><br />
          Please try getting the correct Resource URL using <a
                    href='${CONSTANTS.EXTERNAL_LINKS.DOCS_LINK.MICROSOFT_DYNAMICS_INTEGRATION}'
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link"
                  >
                    Adapt - Microsoft Dynamics Integration
                  </a> and retry logging to Dynamics account or contact <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>.`;
          this.constructExportStatusPopup('Failed', {}, exportType, errorMsg);
        } else if (
          response.errorMsg !== null &&
          response.errorMsg !== undefined
        ) {
          this.constructExportStatusPopup(
            'Failed',
            {},
            exportType,
            response.errorMsg,
          );
        } else {
          this.constructExportStatusPopup('Failed', {}, exportType);
        }
      } else {
        this.constructExportStatusPopup('Failed', {}, exportType);
      }
    } else {
      this.constructExportStatusPopup('Failed', {}, exportType);
    }
  };

  @action
  showOutreachSequencePopUp = () => {
    const thisObj = this;

    const outreachExportSequenceCallback = (
      res = {
        data: {
          mailBoxes: { 'pradeep@adapt.io': 1 },
          sequences: {
            'Meeting No Show': 3,
            'Inbound Sequence': 1,
            'Persona Sequence: Low Touch': 2,
            'Clone test': 5,
          },
        },
        status: 200,
      },
    ) => {
      thisObj.showProcessingExport = false;
      if (res && res.status === 200 && res.data !== undefined)
        if (
          res.data.sequences &&
          res.data.sequences !== undefined &&
          res.data.mailBoxes &&
          res.data.mailBoxes !== undefined
        ) {
          const sequence = res.data.sequences;
          const mailboxes = res.data.mailBoxes;
          const seqkeys = Object.keys(sequence);
          const mailBoxkeys = Object.keys(mailboxes);
          if (seqkeys.length > 0) {
            const sequenceList = seqkeys.map(item => {
              return {
                name: item,
                id: sequence[item],
              };
            });
            const mailBoxList = mailBoxkeys.map(item => {
              return {
                name: item,
                id: mailboxes[item],
              };
            });
            const outreachSequenceSelectedCallback = (
              selectedSequenceId,
              selectedMailBoxId,
              tagValue,
            ) => {
              if (selectedSequenceId === '' && selectedMailBoxId === '')
                thisObj.exportContactsToOutreachFlow(
                  null,
                  true,
                  '',
                  '',
                  tagValue,
                );
              else
                thisObj.exportContactsToOutreachFlow(
                  null,
                  true,
                  selectedSequenceId,
                  selectedMailBoxId,
                  tagValue,
                );

              console.log('selectedSequenceId', selectedSequenceId);
            };
            console.log('sequenceList', sequenceList);
            thisObj.setShowExportLeads(false);

            outreachSequenceState.setPopupValues({
              sequenceList,
              mailBoxList,
              callback: outreachSequenceSelectedCallback,
            });
            outreachSequenceState.setShowPopup(true);
          }
        }

      console.log('sequence', res);
    };
    this.showProcessingExport = true;
    outreachExportSequenceCallback();
    // this.exportContactsMakeApiCall(
    //   URLS.exportLeadsOutreachSequence,
    //   outreachExportSequenceCallback,
    // );
  };

  @action
  showPreferencePopUp = (exportType, exportLeadsCount) => {
    const thisObj = this;
    const typeSelectedCallback = (selectedType, savePreference) => {
      const prePostData = thisObj.exportPostData;
      if (exportType === 'Salesforce')
        prePostData.export_as = selectedType.toUpperCase();
      else if (selectedType !== undefined) prePostData.save_type = selectedType;
      if (selectedType !== undefined)
        prePostData.save_preference = savePreference;
      thisObj.setExportPostData(prePostData);
      if (exportType === 'Zoho')
        thisObj.exportContactsToZohoFlow(exportLeadsCount);
      else if (exportType === 'Salesforce')
        thisObj.askAssignOwnerShipPopup('Salesforce');
      else if (exportType === CRM_EXPORT_TYPE.MICROSOFT_DYNAMICS)
        thisObj.exportLeadsToMicrosoftDynamicsFlow(exportLeadsCount, null);
    };
    this.setShowExportLeads(false, this.additionalOptions);
    const data = {
      title: exportType,
      type: exportType,
      callback: typeSelectedCallback,
    };
    if (exportType === 'Salesforce')
      data.defaultPreferenceCheckBox = false;
    exportTypeState.setPopupValues(data);
    exportTypeState.setShowPopup(true);
  };

  @action
  exportContactsToZoho = (type, source, option) => {
    const thisObj = this;

    const paramsBody = {
      export_type: type,
      source,
    };
    let exportLeadsCount = 1;

    if (option === 'export all') {
      if (
        myLeadsState.selectedList.id === null &&
        myLeadsState.selectedList.id === ''
      ) {
        paramsBody.selected_type = 'All';
        paramsBody.export_ids = 'Nothing';
        exportLeadsCount = myLeadsState.leadsResultCount;
      } else {
        paramsBody.selected_type = 'List';
        paramsBody.export_ids = myLeadsState.selectedList.id;
        exportLeadsCount = myLeadsState.leadsResultCount;
      }
    } else if (option === 'export selected') {
      paramsBody.selected_type = 'Checked';
      paramsBody.export_ids = myLeadsState.bulkPurchaseIds;
      exportLeadsCount = myLeadsState.bulkPurchaseIds.length;
    }

    this.exportPostData = paramsBody;
    this.exportContactsToZohoFlow(exportLeadsCount, true);
  };

  @action
  exportContactsToZohoFlow = (zohoExportCount, appendPostData = false) => {
    const thisObj = this;
    this.showProcessingExport = true;

    if (zohoExportCount !== undefined && zohoExportCount > CRM_EXPORT_LIMIT) {
      thisObj.clearSelectedContacts();
      this.showProcessingExport = false;
      this.exportFailureLimit('Zoho', zohoExportCount);
    } else {
      const zohoExportCallback = res => {
        this.showProcessingExport = false;
        this.exportContactsResponseHandler(res, zohoExportCount, 'Zoho');
      };
      this.exportContactsMakeApiCall(
        URLS.exportSelectedLeadsToZoho,
        zohoExportCallback,
        appendPostData,
      );
    }
  };

  @action
  exportFailureLimit = (
    str,
    exportLeadsCount,
    exportLimit = CRM_EXPORT_LIMIT,
  ) => {
    Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_EXPORT_LIMIT_EXCEED, {
      type: str,
      triedLimit: exportLeadsCount,
      currentLimit: exportLimit,
    });
    const emptyCbk = () => {};
    confirmationPopupState.setPopupValues({
      title: 'Limit Exceeded',
      content: `You can export a maximum of ${exportLimit} contacts in a single transaction.`,
      actionBtnText: 'OK',
      needCancelBtn: false,
      callback: emptyCbk,
    });
    confirmationPopupState.setShowPopup(true);
  };

  @action
  openOAuthPopThruButClick = (tempOAuthData, callback) => {
    const { url, title, width, height, top, left, exportType } = tempOAuthData;
    OAuthWindowOpened = true;
    window.addEventListener('message', function(ev) {
      console.log('data', ev);
      if (ev.data && ev.data.adaptExport === true) {
        console.log('success', ev.data);
        oAuthWindow.close();
        const response = {};
        response.data = ev.data;
        callback(response, null, exportType);
      }
    });
    oAuthWindow = window.open(
      url,
      title,
      `toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no,width=${width},height=${height},top=${top},left=${left}`,
    );

    if (exportType === 'ZOHO') console.log('zoho openOAuthPopThruButClick');
    // showZohoLoginIndicator();
  };

  @action
  openOAuthWindow = (
    url,
    title,
    width,
    height,
    exportType,
    exportCount,
    oAuthCallBack,
    askExportConfimPop = true,
  ) => {
    const thisObj = this;
    if (thisObj.oAuthWindow) thisObj.oAuthWindow.close();

    const left = screen.width / 2 - width / 2;
    const top = screen.height / 2 - height / 2;

    const tempOAuthData = {};
    tempOAuthData.url = url;
    tempOAuthData.title = title;
    tempOAuthData.width = width;
    tempOAuthData.height = height;
    tempOAuthData.top = top;
    tempOAuthData.left = left;
    if (exportType !== undefined) tempOAuthData.exportType = exportType;

    if (askExportConfimPop) {
      const showAskForOAuthPopCallback = () => {
        // console.log('callback');
        thisObj.openOAuthPopThruButClick(tempOAuthData, oAuthCallBack);
      };
      confirmationPopupState.setPopupValues({
        title: `${exportType} Export`,
        content: `Export ${exportCount} lead${
          exportCount > 1 ? 's' : ''
        } to ${exportType}`,
        actionBtnText: 'Continue',

        callback: showAskForOAuthPopCallback,
      });
      confirmationPopupState.setShowPopup(true);
    } else {
      thisObj.openOAuthPopThruButClick(tempOAuthData, oAuthCallBack);
    }

    // oAuthCallBack();
    if (thisObj.oAuthWindow) thisObj.oAuthWindow.focus();
  };

  @action
  trackPurchaseEvent(crmType = '', count, purchaseFlowType) {
    const thisObj = this;

    const mxData = {};
    mxData['Number of contacts purchased'] = count;
    mxData['Purchase Type'] =
      CONSTANTS.CRM_EXPORT_TYPE[crmType.toUpperCase()] || crmType;
    mxData.mobileWaterfall = Utils.isMobileWaterFallEnabled();
    mxData.zeroBounce = Utils.isZeroBounceEnabled();
    mxData.searchType = 'Contact';
    mxData.currentTab = thisObj.checkIsAdvExport() ? 'contact' : 'myleads';
    mxData.purchaseFlowType = purchaseFlowType;
    Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_LB_CONTACT_PURCHASED, mxData);
    Utils.trackRefinerRemainingCredits();
  }

  @action
  exportLeadsToCRM = props => {
    const { type, source, option, exportAs = null } = props;
    const thisObj = this;

    let paramsBody = {};
    paramsBody = {
      export_type: type,
      source,
      isEu: userDetail.featureFlags.EU_CONTACTS,
      ...(exportAs && { export_as: exportAs }),
    };
    let exportLeadsCount = 1;
    let requestType = '';

    if (thisObj.checkIsAdvExport()) {
      exportLeadsCount = advSearchState.getSelectedContactsCount();
      const advPostData = advSearchState.getExportIdsPostData();
      requestType = advSearchState.getExportType();
      paramsBody = { ...paramsBody, ...advPostData };
    } else if (option === 'export selected') {
      paramsBody.contactIds = JSON.stringify(myLeadsState.bulkPurchaseIds);
      exportLeadsCount = myLeadsState.bulkPurchaseIds.length;
      requestType = 'SELECTED';
    } else if (option === 'job update') {
      paramsBody.contactIds = JSON.stringify(myLeadsState.bulkPurchaseIds);
      exportLeadsCount = myLeadsState.bulkPurchaseIds.length;
      paramsBody.listId = myLeadsState.selectedList.id;
      paramsBody.isMyleadsJobExport = true;
      requestType = 'SELECTED';
    } else if (myLeadsState.selectedList.name !== 'All Leads') {
      paramsBody.listId = myLeadsState.selectedList.id;
      exportLeadsCount = myLeadsState.leadsResultCount;
      requestType = 'LIST';
    } else {
      exportLeadsCount = myLeadsState.leadsResultCount;
      requestType = 'ALL';
    }

    paramsBody.requestType = requestType;
    paramsBody.exportRequestCount = exportLeadsCount;
    this.exportPostData = paramsBody;

    this.authorizeToCRM(type);
  };

  @action
  getCRMExportUrl(crmType) {
    const thisObj = this;

    const { exportSource, exportPostData } = thisObj;

    const { requestType, export_as: exportAs } = exportPostData;

    let requestSource = EXPORT_PAGE_SOURCE.MY_LEADS;

    if (exportSource === ADVANCED_SEARCH)
      requestSource = EXPORT_PAGE_SOURCE.ADVANCED_SEARCH;

    const url = Utils.generateUrl(URLS?.crmExport?.export, {
      crmType,
      type: requestType,
      source: requestSource,
      ...(exportAs && { exportType: exportAs }),
    });
    console.log(url, exportPostData);
    return url;
  }

  @action
  authorizeToCRM = crmType => {
    const thisObj = this;
    const { exportPostData } = thisObj;
    const { exportRequestCount } = exportPostData;

    this.showProcessingExport = true;
    if (exportRequestCount > CRM_EXPORT_LIMIT) {
      thisObj.clearSelectedContacts();
      this.showProcessingExport = false;
      this.exportFailureLimit(crmType, exportRequestCount);
    } else {
      const crmAuthorizeCallback = res => {
        this.showProcessingExport = false;
        this.exportContactsToCrmResponseHandler(res, crmType);
      };

      thisObj.exportPostData = {
        ...thisObj.exportPostData,
        now: Date.now(),
      };

      this.exportContactsMakeApiCall(
        thisObj.getCRMExportUrl(crmType.toUpperCase()),
        crmAuthorizeCallback,
        true,
      );
    }
  };

  @action
  exportLeadsToCRMFlow = (accountOwners, crmType) => {
    const thisObj = this;
    const { exportPostData } = this;
    if (accountOwners !== undefined && accountOwners !== '')
      exportPostData.accountOwners = accountOwners;

    this.exportPostData = exportPostData;
    this.showProcessingExport = true;

    const crmExportCallback = res => {
      this.showProcessingExport = false;
      thisObj.exportContactsToCrmResponseHandler(res, crmType);
    };

    thisObj.exportPostData = {
      ...thisObj.exportPostData,
      now: Date.now(),
    };

    this.exportContactsMakeApiCall(
      thisObj.getCRMExportUrl(crmType.toUpperCase()),
      crmExportCallback,
      false,
    );
  };

  @action
  askAssignOwnerShipPopup = exportType => {
    const thisObj = this;
    const assignOwnerShipCallback = () => {
      thisObj.assignOwnerShipToCRM(exportType);
    };
    const donotAssignOwnerShipCallback = () => {
      Utils.mixpanelTrack(
        CONSTANTS.MX_ML_EVENTS.ASSIGN_OWNERS[exportType.toUpperCase()],
        {
          isAllowed: 'No',
        },
      );
      thisObj.exportLeadsToCRMFlow({}, exportType);
    };
    let assignOwnerText = 'Do you want to assign owners to these accounts?';
    if (exportType === 'Hubspot')
      assignOwnerText = 'Do you want to assign owners to these companies?';
    confirmationPopupState.setPopupValues({
      title: `Export ${
        thisObj.exportPostData.save_type ? thisObj.exportPostData.save_type : ''
      } to ${exportType} `,
      content: assignOwnerText,
      actionBtnText: 'Yes',
      customClassName: 'ask-assign-owners',

      callback: assignOwnerShipCallback,
      actionBtnTextCancel: 'No, Continue to Export',
      cancelCallback: donotAssignOwnerShipCallback,
    });
    confirmationPopupState.setShowPopup(true);
  };

  @action
  assignOwnerShipToCRM = exportType => {
    const thisObj = this;
    const assignedOwners = assignOwnerData => {
      Utils.mixpanelTrack(
        CONSTANTS.MX_ML_EVENTS.ASSIGN_OWNERS[exportType.toUpperCase()],
        {
          isAllowed: 'Yes',
        },
      );
      thisObj.exportLeadsToCRMFlow(assignOwnerData, exportType);
    };
    const withoutAssignOwners = () => {
      Utils.mixpanelTrack(
        CONSTANTS.MX_ML_EVENTS.ASSIGN_OWNERS[exportType.toUpperCase()],
        {
          isAllowed: 'Yes',
        },
      );
      thisObj.exportLeadsToCRMFlow({}, exportType);
    };
    ownershipMappingState.setExportSource(thisObj.exportSource);
    ownershipMappingState.setExportType(exportType);
    ownershipMappingState.setPostData(this.exportPostData);
    ownershipMappingState.setExportCallback(assignedOwners);
    ownershipMappingState.setCancelCallback(withoutAssignOwners);
    ownershipMappingState.setCompanyExport(false);
    ownershipMappingState.setShowPopup(true);
  };

  // Use this function to handle api response for all export going forward
  @action
  exportContactsToCrmResponseHandler = (res, crmType) => {
    const thisObj = this;

    // TODO - while working on all crm integration need to make changes here

    if (res && res.data) {
      const response = res.data;
      const { exportPostData } = thisObj;
      const {
        requestType,
        exportRequestCount,
        isMyleadsJobExport,
      } = exportPostData;

      const crmTypeVal = crmType && thisObj.exportPostData.export_type;
      const { responseCode = '', responseData } = response;
      switch (responseCode) {
        case 303:
        case 412:
        case 407:
          crmIntegrationState.setShowConnectErrorMsg({
            showPopup: true,
            crmType: crmTypeVal,
            ...response,
            ...responseData,
            redirectToIntegrations: responseCode === 303,
          });
          break;
        case 417:
          const { inputRequired } = responseData;
          if (inputRequired === 'ACCOUNT_OWNERS')
            this.askAssignOwnerShipPopup(crmTypeVal);
          if (inputRequired === 'CRM_PREFERENCES')
            if (crmType === CRM_EXPORT_TYPE.SALESFORCE)
              this.showPreferencePopUp(crmType);
          break;
        case 200:
          if (
            requestType === ASYNC_EXPORT ||
            requestType === ASYNC_EXPORT_CRITERIA ||
            (this.exportSource === MY_LEADS &&
              exportRequestCount > 5 &&
              !isMyleadsJobExport)
          ) {
            // for async flow, getMemberEntity not made so saving preference when export success
            if (
              this.exportSource === MY_LEADS &&
              exportPostData.export_as &&
              exportPostData.save_preference
            )
              userDetail.updateUserInfo({
                teamCRMPreferences: {
                  ...(userDetail.userInfo.teamCRMPreferences || {}),
                  [crmType.toUpperCase()]: {
                    ...(userDetail.userInfo.teamCRMPreferences?.[crmType] ||
                      {}),
                    export_as: exportPostData.export_as.toLowerCase(),
                  },
                },
              });
            thisObj.trackPurchaseEvent(
              crmType,
              exportRequestCount,
              requestType,
            );
            advSearchState.setAsyncPurchaseOrExportMsg('CRM_EXPORT');
            this.additionalOptions.callback('SUCCESS');
          } else {
            const {
              duplicateCount,
              failedCount,
              newlyAddedCount,
              successCount,
              totalCount,
              contactViews = [],
              contactIdsWithoutEmail = [],
              isCreditLimitExhausted = false,
            } = response || {};

            if (this.checkIsAdvExport()) {
              advSearchState.updateSearchResult(contactViews);
              thisObj.trackPurchaseEvent(crmTypeVal, totalCount, null);
              advSearchState.setSyncPurchaseOrExportData({
                type: 'CRM_EXPORT',
                totalCount,
                newlyAddedCount,
                successCount,
                duplicateLeads: duplicateCount,
                isZbEnabled: Utils.isZeroBounceEnabled(),
                isCreditLimitExhausted,
                contactIdsWithoutEmail,
              });
            } else {
              const resData = {
                responseCode: 200,
                exportSuccessCount: successCount,
                newDownloadedCount: newlyAddedCount,
                exportFailedCount: failedCount,
                duplicateLeadCount: duplicateCount,
                creditsReduced: newlyAddedCount,
                totalCount,
                contactIdsWithoutEmail,
              };
              if (isMyleadsJobExport) {
                myLeadsState.updateSearchResult(contactViews);
                if (contactViews?.length > 0)
                  Utils.mixpanelTrack(
                    CONSTANTS.MX_ML_EVENTS.ML_JOB_CHANGE_PURCHASED,
                    {
                      contactIds: contactViews.map(contact => {
                        return contact.id;
                      }),
                      exportType: crmType,
                    },
                  );
              }
              this.constructExportStatusPopup('Success', resData, crmType);
            }
            this.additionalOptions.callback('SUCCESS');
            this.setShowExportLeads(false);

            loginValidate();
          }
          thisObj.clearSelectedContacts();
          break;
        case 402:
        case 426:
        case 430:
          // Subscription based errors
          const { userInfo } = userDetail;
          const { memberSubscription } = userInfo;
          if (memberSubscription !== null && memberSubscription !== undefined) {
            if (Utils.isFreeTrialPlan())
              userDetail.setShowUpgradeCreditPopup(true);
            else Utils.showCreditExpiredPopup('downloads');
          } else {
            this.setShowExportLeads(false);
            Utils.showUserPricingPopup(true, 'downloads', false);
          }
          this.additionalOptions.callback('FAILURE');
          this.showProcessingExport = false;
          thisObj.clearSelectedContacts();
          break;
        default:
          if (
            requestType === ASYNC_EXPORT ||
            requestType === ASYNC_EXPORT_CRITERIA
          ) {
            advSearchState.setAsyncPurchaseOrExportMsg('UNKNOWN_ERROR');
          } else {
            this.constructExportStatusPopup('Failed', {}, crmType);
          }
          this.additionalOptions.callback('FAILURE');
          break;
      }
    } else {
      this.additionalOptions.callback('FAILURE');
      this.constructExportStatusPopup('Failed', {}, crmType);
    }
  };
}

const exportLeadsState = new ExportLeadsState();

const ExportLeads = observer(props => {
  const { enabledExportTypes = allExportTypes } = props;
  const [showAeUpgradePopup, setShowAeUpgradePopup] = useState(false);
  const [showAeConnectInbox, setShowAeConnectInbox] = useState(false);
  const [showAeExportCrm, setShowAeExportCrm] = useState(false);
  const [exportOption, setExportOption] = useState('');
  const [upgradeValue, setUpgradeValue] = useState('');
  const [showSgConnectApi, setSgConnectApi] = useState(false);

  const { featureFlags } = userDetail;
  const { CSV_EXPORT = false, CRM_EXPORT = false, LEAD_BUILDER = false } =
    featureFlags || {};

  const {
    exportSource,
    showProcessingExport,
    showExportLeads,
    isCrmExportLimitCrossed,
  } = exportLeadsState;

  const exportOptinListMap = exportOptions.filter(option =>
    enabledExportTypes.includes(option.label),
  );

  const isCsvEnabled =
    (exportSource === ADVANCED_SEARCH && LEAD_BUILDER && CSV_EXPORT) ||
    (exportSource !== ADVANCED_SEARCH && CSV_EXPORT);

  const isCrmEnabled =
    (exportSource === ADVANCED_SEARCH && LEAD_BUILDER && CRM_EXPORT) ||
    (exportSource !== ADVANCED_SEARCH && CRM_EXPORT);

  const exportContactToSalesgear = (option, isExportEnabled) => {
    exportLeadsState.setShowExportLeads(false);
    if (isExportEnabled) {
      setExportOption(option);
      if (userDetail?.salesgearUserInfo?.email) {
        Utils.mixpanelTrack(CONSTANTS.MX_EVENTS_AE.exportContact);
        setShowAeExportCrm(true);
      } else {
        setSgConnectApi(true);
      }
    } else {
      commonUpgradePopupState.setShowUpgradePopup(
        UPGRADE_TRIGGERS.EXPORT_SELECTED_TO_CRM_IN_MY_LEADS,
      );
    }
  };

  const closeSgConnectApiPopup = (proceedToExport = false) => {
    setSgConnectApi(false);
    if (proceedToExport)
      exportContactToSalesgear(exportLeadsState.exportOption, isCrmEnabled);
  };

  const hideSalesgearConnectInbox = () => {
    setShowAeConnectInbox(false);
  };

  const hideAeExportCrm = () => {
    setShowAeExportCrm(false);
  };

  const processingLoader = value => {
    exportLeadsState.setShowProcessingExport(value);
    hideAeExportCrm();
  };

  const showSalesgearUpgrade = value => {
    setUpgradeValue(value);
    processingLoader(false);
    setShowAeUpgradePopup(true);
  };

  const hideSalesgearUpgrade = () => {
    setShowAeUpgradePopup(false);
  };

  const showSalesgearConnectInbox = () => {
    hideAeExportCrm();
    processingLoader(false);
    setShowAeConnectInbox(true);
  };

  const clearSelectedFields = () => {
    exportLeadsState.clearSelectedContacts();
  };

  const aeExportResult = (resStatus, data = {}) => {
    processingLoader(false);
    if (resStatus === 'failed') {
      exportLeadsState.constructExportStatusPopup('Failed', data, 'Salesgear');
    } else {
      exportLeadsState.constructExportStatusPopup(
        'Success',
        resStatus,
        'Salesgear',
      );
    }
  };

  const exportLimitExceed = count => {
    processingLoader(false);
    exportLeadsState.exportFailureLimit('Salesgear', count);
  };

  const isNotHpeUser = crmType => {
    const { email = '' } = (userDetail && userDetail.userInfo) || {};
    if (crmType && crmType.toLowerCase() === 'outreach') {
      if (email) {
        return Utils.checkEmailDomain(email, CONSTANTS.HP_DOMAIN_URL);
      }
    }
    return true;
  };

  return (
    <div className="export-leads">
      {showSgConnectApi && (
        <SalesgearAPIConnect closePopup={closeSgConnectApiPopup} />
      )}
      <ExportLeadsTypePopup />
      <OutreachSequencePopup />
      <PipedriveAuthenticationPopup />
      <MarketoAuthenticationPopup />
      <MicrosoftDynamicsAuthenticationPopup />
      <OwnershipMappingPopup />
      {showAeUpgradePopup && (
        <SalesgearUpgradePopup
          hide={hideSalesgearUpgrade}
          value={upgradeValue}
        />
      )}
      {showAeConnectInbox && (
        <SalesgearConnectInbox hide={hideSalesgearConnectInbox} />
      )}
      {showAeExportCrm && (
        <SalesgearExportCRM
          hide={hideAeExportCrm}
          option={exportOption}
          upgrade={showSalesgearUpgrade}
          loader={processingLoader}
          resultResponse={aeExportResult}
          showConnectInbox={showSalesgearConnectInbox}
          limit={exportLimitExceed}
          clearSelectedFields={clearSelectedFields}
        />
      )}
      <div
        className={`processing-exportCont${
          showProcessingExport ? '' : ' hide'
        }`}
      >
        <p className="processing-export">
          Please wait, we're processing your export
        </p>
      </div>
      {showExportLeads && (
        <>
          <div className="export-leads-popup common-popup">
            <div className="popup-wrap">
              <div
                className="popup-close"
                title="Click here to close"
                onClick={() => exportLeadsState.setShowExportLeads(false)}
              >
                <CloseIcon />
              </div>
              <div className="title">Export Leads</div>
              {isCrmExportLimitCrossed && (
                <div className="limit-exceed-crm-error">
                  <InfoIcon width={14} height={14} className="info-icon" />
                  Please select less than {CRM_EXPORT_LIMIT} contacts to enable
                  export options
                </div>
              )}
              <div className="popup-content-wrap">
                {exportOptinListMap.map((item, index) => {
                  const { icon: SvgIcon, label, className } = item;
                  return item.label === 'CSV' ? (
                    <div
                      className={`export-optin-item${
                        isCsvEnabled ? '' : ' blocked-wrap'
                      }`}
                      key={`export-option-${index}`}
                      onClick={e =>
                        exportLeadsState.checkAndexport(
                          label,
                          'salesLift',
                          exportLeadsState.exportOption,
                          isCsvEnabled,
                        )
                      }
                    >
                      {/* {!isCsvEnabled && (
                        <LockIcon className="dropdown-icon plus-icon lock-icon" />
                      )} */}
                      <div className="option-icon-wrap">
                        <SvgIcon className={`option-icon ${className}`} />
                      </div>
                      <div className="option-title">{label}</div>
                    </div>
                  ) : label === 'Salesgear' ? (
                    Utils.isSalesgearExportEnabled() ? (
                      <div
                        className={`export-optin-item${
                          isCrmExportLimitCrossed ? ' limit-exceed-disable' : ''
                        }`}
                        onClick={e =>
                          exportContactToSalesgear(
                            exportLeadsState.exportOption,
                            isCrmEnabled,
                          )
                        }
                        key={`export-option-${index}`}
                      >
                        {/* <span className="newFeature exp-new-btn">new</span> */}
                        <div className="option-icon-wrap">
                          <img
                            className={`option-icon ${className}`}
                            src={SalesgearLogo}
                            alt="salesgear"
                          />
                        </div>
                        <div className="option-title">{label}</div>
                      </div>
                    ) : null
                  ) : (
                    isNotHpeUser(label) && (
                      <div
                        className={`export-optin-item  ${
                          exportSource === ADVANCED_SEARCH
                            ? ' crm-export-option-item'
                            : ''
                        } ${
                          isCrmEnabled
                            ? isCrmExportLimitCrossed
                              ? ' limit-exceed-disable'
                              : ''
                            : ' blocked-wrap'
                        }`}
                        key={`export-option-${index}`}
                        onClick={e =>
                          exportLeadsState.checkAndexport(
                            label,
                            'salesLift',
                            exportLeadsState.exportOption,
                            isCrmEnabled,
                          )
                        }
                      >
                        {/* {!isCrmEnabled && (
                          <LockIcon className="dropdown-icon plus-icon lock-icon" />
                        )} */}
                        <div className="option-icon-wrap">
                          <SvgIcon className={`option-icon ${className}`} />
                        </div>
                        <div className="option-title">{label}</div>
                      </div>
                    )
                  );
                })}
              </div>
            </div>
          </div>
          <div
            className="common-popup-mask"
            onClick={() => exportLeadsState.setShowExportLeads(false)}
          />
        </>
      )}
    </div>
  );
});

export { ExportLeads, exportLeadsState };
export default ExportLeads;
